var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareSalesMultiChannelCampaigns = function SvgYeswareSalesMultiChannelCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 19.422,
    fill: "#ECF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.602 23.666a1.597 1.597 0 0 0-3.194 0v1.236L26.423 34.26a.797.797 0 0 0-.552.76v9.511a.799.799 0 0 0 .559.761l2.076.652a.798.798 0 0 1 .558.761v4.137a7.193 7.193 0 0 0 7.185 7.153h.034a7.193 7.193 0 0 0 7.15-7.212v-.16l11.975 3.753v1.223a1.597 1.597 0 0 0 3.194 0V23.666ZM40.24 50.791a3.991 3.991 0 0 1-3.973 4.011h-.019a3.992 3.992 0 0 1-3.992-3.966v-2.63a.798.798 0 0 1 1.038-.761l6.387 2.002a.799.799 0 0 1 .559.761v.583ZM23.476 34.045a1.597 1.597 0 1 0-3.193 0l.008 11.176a1.597 1.597 0 0 0 1.597 1.597h-.008a1.596 1.596 0 0 0 1.596-1.558V34.044Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareSalesMultiChannelCampaigns;